const translations = {
  "en": {
    "Check other agents, I’ll alert you when this one finds something worth your attention.": "Check other agents, I’ll alert you when this one finds something worth your attention.",
    "New Report": "New Report",
    "No more data": "No more data",
    "No Smart Signals Yet": "No Smart Alerts Yet"
  },
  "zh-tw": {
    "Check other agents, I’ll alert you when this one finds something worth your attention.": "查看其他 Agent，當這個 Agent 找到值得你關注的內容時，我會通知你。",
    "New Report": "最新報告",
    "No more data": "已載入全部內容",
    "No Smart Signals Yet": "尚無智慧警報"
  }
};

export default translations;
